export default __webpack_public_path__ + "static/media/Settings_24.ea3160c2.svg";